import { createApp } from 'vue'

export const App = {
  delimiters: ['[[', ']]'],
  data() {
    return {
      confirm: false,
      share: false,
      contact: false,
      notMember: false,
      urlCopied: false
    }
  },

  methods: {
    handleModalClose() {
      this.share = false
    },
    handleShareClicked() {
      this.share = true
    },
    handleCopyClicked() {
      let result = true
      if (navigator.clipboard) {
        navigator.clipboard.writeText(window.location.href)
      } else {
        const input = document.createElement('input')
        input.value = window.location.href
        input.readOnly = true
        input.style.position = 'absolute'
        input.style.opacity = '0'
        document.body.appendChild(input)
        console.log(window.location.href)
        input.setSelectionRange(0, window.location.href.length)
        result = document.execCommand('copy')
      }
      this.urlCopied = result
    },
    handleContactClicked() {
      this.contact = true
    },
    handleContactClose() {
      this.contact = false
    },
    handleNotMemberClose() {
      this.notMember = false
    },
    handleURLCopiedClose() {
      this.urlCopied = false
    },
    scrollToPurchase() {
      const purchaseArea = document.getElementById("list_ticket");
      purchaseArea.scrollIntoView();
    }
  },
  mounted() {
    if (window.location.search.indexOf('not_member') != -1) {
      this.notMember = true
    }
  }
}
if (document.getElementById('app')) {
  createApp(App).mount('#app')
}
